import * as THREE from 'three';
import * as SelectionUtils from '../interaction/SelectionUtils';
import { global } from '../../core/GlobalState';
export function startMoveObjectDrag() {
    const object = SelectionUtils.setSelectedObject();
    if (!object || !object.parent)
        return;
    if (!global.orbManager.getOrb(object.parent.uuid))
        return;
    global.isDragging = true;
    global.isHoldingOrb = true;
    global.audioBus.startSustain('orbHold');
    global.dragTargetObject = object;
    const dir = new THREE.Vector3();
    global.camera.getWorldDirection(dir);
    global.dragDistance = global.camera.position.distanceTo(object.parent.position);
    // ✅ Apply outline for visual feedback while dragging
    SelectionUtils.applyOutlineToObject(object, '#00ffff', 3); // cyan or any other drag-specific color
}
export function releaseMoveObjectDrag() {
    var _a;
    if (!global.isDragging || !global.dragTargetObject)
        return;
    const parentGroup = global.dragTargetObject.parent;
    if (!parentGroup)
        return;
    const orb = global.orbManager.getOrb(parentGroup.uuid);
    if (!orb)
        return;
    const currentPos = orb.group.position.clone();
    const releaseVelocity = (_a = global.lastDragTargetPos) === null || _a === void 0 ? void 0 : _a.clone().sub(currentPos).multiplyScalar(0.2);
    if (releaseVelocity) {
        orb.setVelocity(releaseVelocity);
    }
    global.isDragging = false;
    if (global.isHoldingOrb) {
        global.audioBus.stopSustain('orbHold');
        global.isHoldingOrb = false;
    }
    global.dragTargetObject = null;
    global.lastDragTargetPos = null;
    // ✅ Clear the outline after dragging ends
    SelectionUtils.clearOutline();
}
export function updateDraggedOrb() {
    if (!global.isDragging || !global.dragTargetObject)
        return;
    const dir = new THREE.Vector3();
    global.camera.getWorldDirection(dir);
    const targetPos = global.camera.position.clone().add(dir.multiplyScalar(global.dragDistance));
    const parentGroup = global.dragTargetObject.parent;
    if (!parentGroup)
        return;
    const orb = global.orbManager.getOrb(parentGroup.uuid);
    if (!orb)
        return;
    const currentPos = orb.group.position.clone();
    // Looser tracking factor for "throwable" feel
    const smoothing = 0.45;
    const smoothedPos = currentPos.lerp(targetPos, smoothing);
    orb.setPosition(smoothedPos);
    // Save for velocity on release
    global.lastDragTargetPos = targetPos.clone();
}
